import React, {useState} from 'react';
import {BrowserRouter as Router, useLocation} from "react-router";
import {SocialLoginContext} from "../context/social-login-context";
import SecurSpaceContent from "./SecurSpaceContent";
import GlobalModalManager from "../components/modals/GlobalModalManager";
import ExternalContent from './content-routes/ExternalContent';
import {externalRoutePathnames} from "../components/constants/securspace-constants";

interface SocialLoginUser {
  [key: string]: any;
}

const SecurSpaceRouterContent = () => {
  const location = useLocation();
  const isExternalRoute = externalRoutePathnames.includes(location.pathname);

  return (
    <GlobalModalManager>
      {isExternalRoute ? <ExternalContent/> : <SecurSpaceContent/>}
    </GlobalModalManager>
  );
};

const SecurSpaceRouter = () => {
  const [socialLogin, setSocialLogin] = useState<{ user: SocialLoginUser | null }>({user: null});

  const contextValue: {
    socialLogin: { user: SocialLoginUser | null };
    setSocialLoginUser: (user: SocialLoginUser | null) => void;
    clearSocialLoginUser: () => void;
  } = {
    socialLogin,
    setSocialLoginUser: (user: SocialLoginUser | null) => setSocialLogin({user}),
    clearSocialLoginUser: () => setSocialLogin({user: null})
  };

  return (
    <SocialLoginContext.Provider value={contextValue as any}>
      <Router>
        <SecurSpaceRouterContent/>
      </Router>
    </SocialLoginContext.Provider>
  );
};

export default SecurSpaceRouter;
